import { Controller } from "@hotwired/stimulus"

function storageKey() {
  return `tab-memory:${window.location.pathname}`
}

// Turbo drops the fragment from the URL after a GET form submission, which
// resets the selected GOV.UK tab; remember the fragment around the navigation
// and reinstate it before the tabs initialise on the next load.
export default class extends Controller {
  static values = { restore: Boolean }

  connect() {
    if (!this.restoreValue) return

    const remembered = sessionStorage.getItem(storageKey())
    sessionStorage.removeItem(storageKey())
    if (!remembered || window.location.hash) return

    if (this.element.querySelector(`a[href="${remembered}"]`)) {
      history.replaceState(history.state, "", remembered)
    }
  }

  save() {
    if (window.location.hash) {
      sessionStorage.setItem(storageKey(), window.location.hash)
    } else {
      sessionStorage.removeItem(storageKey())
    }
  }
}
